<template>
  <div class="plagin-wrapper layout" v-if="config && config.src">
    <template v-if="config.src.pc && !/pc.png$/i.test(config.src.pc)">
      <img class="show-for-md" :src="config.src.pc" @click="showRules" alt="Sisley Paris" />
    </template>
    <template v-if="config.src.h5 && !/h5.png$/i.test(config.src.h5)">
      <img class="hide-for-md" :src="config.src.h5" @click="showRules" alt="Sisley Paris" />
    </template>
    <!-- 兑换规则 -->
    <Dialog :show="visible" wrapCls="mall-rules" @hide="hideRules">
      <div class="exchange-rules__title">规则</div>
      <div class="exchange-rules__detail">
        <VueScroll :ops="vsOpts">
          <!-- <div class="module">
            <div class="module-title">1、如何兑换礼品？</div>
            <div class="module-content">1、在线支付20元运费，即可获得sisley希思黎抗皱修活御致眼唇霜2ml体验装。</div>
          </div> -->
          <div class="module">
            <!-- <div class="module-title">2、兑换积分何时扣除？</div> -->
            <div class="module-content">1、 活动商品请单独下单，仅限在线支付，不支持货到付款。</div>
          </div>
          <div class="module">
            <!-- <div class="module-title">3、积分兑换的商品怎么发货？</div> -->
            <div class="module-content">2、 同一ID限购一单，相同收货地址及收货手机号均视为同一ID，重复下单无法发货，敬请谅解。</div>
          </div>
          <div class="module">
            <!-- <div class="module-title">4、兑换成功后能否取消？</div> -->
            <div class="module-content">3、 一经售出不支持退款，如活动商品有质量问题，请咨询在线美容顾问。</div>
          </div>
        </VueScroll>
      </div>
      <button class="btn--primary" @click="onConfirm">确定</button>
    </Dialog>
  </div>
</template>

<script>
import 'vuescroll/dist/vuescroll.css';
import VueScroll from 'vuescroll/dist/vuescroll-native';
import Dialog from '@/components/Dialog.vue';
import acitonMixins from "@/utils/action.mixins";

export default {
  name: 'TrialByPostModal',
  mixins: [acitonMixins],
  components: { VueScroll, Dialog },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      vsOpts: {
        bar: {
          background: '#F6F6F6'
        }
      },
      visible: false
    };
  },
  methods: {
    showRules() {
      this.visible = true;
    },
    hideRules() {
      this.visible = false;
    },
    onConfirm() {
      this.actionHandler(this.config.action);
    }
  }
}
</script>

<style lang="scss" scoped>
  .plagin-wrapper {
    box-sizing: border-box; width: 100%;
    img { width: 100%; height: auto; }
  }
  // 兑换规则
  ::v-deep .mall-rules .dialog-container  {
    width: 285px; min-width: 285px; height: 464px; transition: all 0.2s ease-in;
    .dialog-body {
      flex-direction: column; padding: 0 20px;
      .exchange-rules__title { font-size: 14px; color: #000; line-height: 16px; text-align: center; margin-top: 30px; }
      .exchange-rules__detail {
        height: 300px; margin-top: 18px; overflow: auto;
        .module {
          margin-top: 28px;
          .module-title { font-size: 12px; color: #222; font-weight: 700; line-height: 20px; }
          .module-content { font-size: 12px; color: #666; line-height: 20px; }
        }
      }
      .btn--primary { width: 245px; margin: 20px auto 0; }
    }
  }

  @media screen and (min-width: 48em) {
    // 兑换规则
    ::v-deep .mall-rules .dialog-container {
      width: 730px; max-width: 100%;
      .dialog-body {
        padding: 0 60px;
        .exchange-rules__title { font-size: 1rem; color: #000; font-weight: 700; line-height: 22px; text-align: center; margin-top: 58px; }
        .exchange-rules__detail {
          margin-top: 40px; overflow: auto;height: 224px;
        }
        .btn--primary { width: 286px; margin: 20px auto 0; }
      }
    }
  }
</style>